import type {
  AuthStateSubscriber,
  IAuthRepository,
} from '../repositories/IAuthRepository.js';

interface Dependencies {
  authRepository: IAuthRepository;
}

export function createObserveAuthStateUseCase({ authRepository }: Dependencies) {
  return function observeAuthState(subscriber: AuthStateSubscriber): () => void {
    return authRepository.observeAuthState(subscriber);
  };
}
